import { createSelector } from 'reselect';

const casesState = state => {
  return state.cases;
};

export const getCaseManagerId = createSelector([casesState], data => data.caseManagerId);
